<template>
    <div>
        <template v-if="readOnly">
            <div class="form-label p-5px">
                Segregation Check: {{ question.data.return_value || 'Validated successfully' }}
            </div>
        </template>
        <template v-else>
            <el-button
                type="primary"
                :loading="loading"
                @click="check"
                class="mr-10px"
                :disabled="sections.length == 0"
            >
                <span>Check Segregation</span>
            </el-button>
            <span v-if="checked" :class="checkMessage ? 'text-danger' : 'text-success'">
                <i class="fa" :class="checkMessage ? 'fa-times' : 'fa-check'"></i>
                <span class="ml-5px">
                    <template v-if="checkMessage">
                        {{ checkMessage }}
                    </template>
                    <template v-else> Validated successfully </template>
                </span>
            </span>
        </template>
    </div>
</template>

<script>
import FormQuestion from '@/data/FormQuestion';
import ncbapimixin from './ncbapimixin';

export default {
    props: {
        question: { type: FormQuestion, required: true },
        form: { type: Object, required: false },
        sections: { type: Array, required: true },
        readOnly: {
            type: Boolean,
            default() {
                return false;
            },
        },
    },
    mixins: [ncbapimixin],
    data() {
        return {
            loading: false,
            checkMessage: null,
            checked: false,
        };
    },
    watch: {
        checkMessage(value) {
            this.question.data.return_value = value;
        },
    },
    methods: {
        check() {
            const params = this.getRelatedQuestionsValues(this.sections);
            this.question.checkSegregation({
                params: {
                    question_id: this.question.id,
                    api_params: params,
                },
                beforesend: () => {
                    this.checkMessage = null;
                    this.checked = false;
                    this.loading = true;
                },
                complete: () => {
                    this.loading = false;
                    this.checked = true;
                },
                success: (op, response, data) => {
                    if (data instanceof Array) {
                        this.checkMessage = data.join('\n');
                    } else {
                        this.checkMessage = 'Segregation validation not successfull.';
                    }
                },
                failure: (err, response) => {
                    if (err instanceof Error) {
                        this.$notify.error({
                            title: this.$t('Error'),
                            message: err.message,
                        });
                    } else {
                        this.$notify.error({
                            title: this.$t('Error'),
                            message: response.meta.display_message,
                        });
                    }
                },
            });
        },
    },
};
</script>
